<template lang="pug">
    div
        //CrudForm(
            v-bind="staticData"
            :fields="formFields"
            :customRules="customRules"
            @submitForm="submitForm"
            noPadding
            )
        model-form(
            submit-text="guardar"
            v-bind="formProps"
            v-model="formData"
            no-buttons
            )
            branch-offices-list(
                :items="listItems"
                noEdit
                slot="append"
                )
</template>

<script>
//
import { mapActions } from 'vuex'
//
import { ModelForm } from '@/components/reusable_components/next'
//
import ProviderService from '@/services/api/provider/ProviderService'
//
import { BranchOfficesList } from '@/components/lists'
import ProviderInformationFields from './ProviderInformationFields'
//
export default {
    components: {
        BranchOfficesList,
        ModelForm,
    },
    name: 'provider-information',
    props: {},
    data: function() {
        return {
            formData: {},
            formFields: ProviderInformationFields,
            listItems: [],
            formLoading: false,
            //titulo
            provider: {},
        }
    },
    computed: {
        //-
        formProps() {
            return {
                fields: this.formFields,
                editable: false,
                switchEdit: false,
                readOnly: true,
            }
        },
    },
    methods: {
        /**
         *
         */
        async fillFields() {
            //
            ProviderService.fetchProvider(this.$route.params.id)
                .then(this.setFormData)
                .catch(e => console.log('error: ', e))
        },
        setFormData: function(model) {
            this.formData = model
            this.listItems = model.branch_offices
            this.listItems = [...this.listItems]
        },
        //-
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        //-
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: async function() {
        //
        this.fillFields()
        //this.setTitleTopBar('Detalle proveedor')
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
